import React from 'react';
import { ff } from '../../../theme';

export const WalletOutlineIcon: React.FC<{ size?: number; color?: string }> = ({
  size = 15,
  color = ff.muted,
}) => (
  <svg width={size} height={size} viewBox="0 0 15 15" fill="none" aria-hidden>
    <path
      d="M2.5 4.5C2.5 3.67157 3.17157 3 4 3H11C11.8284 3 12.5 3.67157 12.5 4.5V10.5C12.5 11.3284 11.8284 12 11 12H4C3.17157 12 2.5 11.3284 2.5 10.5V4.5Z"
      stroke={color}
      strokeWidth="1.1"
    />
    <path d="M2.5 6H12.5" stroke={color} strokeWidth="1.1" />
    <circle cx="9.75" cy="9" r="0.85" fill={color} />
  </svg>
);

export const WalletClockIcon: React.FC<{ size?: number; color?: string }> = ({
  size = 12,
  color = 'rgba(255,255,255,0.5)',
}) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden>
    <circle cx="6" cy="6" r="4.75" stroke={color} strokeWidth="1.1" />
    <path d="M6 3.75V6.25L7.75 7.5" stroke={color} strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

/** Figma 6430:76 — diagonal withdraw arrow */
export const WalletWithdrawArrowIcon: React.FC<{ size?: number; color?: string }> = ({
  size = 15,
  color = ff.ink,
}) => (
  <svg width={size} height={size} viewBox="0 0 15 15" fill="none" aria-hidden>
    <path
      d="M4.5 10.5L10.5 4.5M10.5 4.5H6.25M10.5 4.5V8.75"
      stroke={color}
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
